import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

import { LocalStorageHelpers } from "@ai360/core";

import { messages } from "../i18n-messages";
import * as actions from "../actions";
import * as selectors from "../selectors";
import { useAppSelector, useAppDispatch } from "~/store/hooks";
import { Button, TextInput } from "~/core";

const { LoginState } = actions;

export interface IPasswordEntryProps {
    onError: (error: any) => void;
    doVersionCheck: () => Promise<boolean>;
}

export const PasswordEntry = (props: IPasswordEntryProps): JSX.Element => {
    const { onError } = props;
    const { formatMessage } = useIntl();
    const history = useHistory();
    const dispatch = useAppDispatch();

    const error = useAppSelector(selectors.getError);
    const loginEmail = useAppSelector(selectors.getLoginEmail);

    const loginPassword = useAppSelector(selectors.getLoginPassword);

    const email = loginEmail || LocalStorageHelpers.get(LocalStorageHelpers.USERNAME) || "";
    const [password, setPassword] = useState<string>(loginPassword || "");
    const [txtPassword, setTxtPassword] = useState<Record<string, any>>(null);

    function _clearPassword() {
        setPassword("");
        if (txtPassword) {
            txtPassword.input.focus();
        }
    }

    function _handleError(err) {
        _clearPassword();
        onError(err);
        dispatch(actions.setProcessing(false));
    }

    function login() {
        dispatch(actions.setProcessing(true));
        dispatch(actions.setError(null));
        if (password.length === 0) {
            _handleError(formatMessage(messages.passwordRequired));
            return;
        }
        if (props.doVersionCheck) {
            props.doVersionCheck().then((isRefreshing) => {
                if (!isRefreshing) {
                    dispatch(actions.login(email, password, history));
                }
            });
        } else {
            dispatch(actions.login(email, password, history));
        }
    }

    function recoverPassword(evt) {
        evt.preventDefault();
        dispatch(actions.setError(null));
        dispatch(actions.setLoginState(LoginState.RECOVER_PASSWORD));
    }

    useEffect(() => {
        if (error) {
            _clearPassword();
            dispatch(actions.setProcessing(false));
        }
    }, [error]);

    const inputFormProps = {
        onKeyDown: (e) => {
            if (e.key === "Enter") {
                login();
            }
        },
    };
    return (
        <div>
            <div className="login-input-container">
                <TextInput
                    tabIndex={1}
                    value={email}
                    disabled
                    autoComplete="username"
                    name="username"
                    placeholderText={formatMessage(messages.usernameLbl)}
                />
                <TextInput
                    tabIndex={2}
                    value={password}
                    password
                    autoComplete="current-password"
                    name="password"
                    placeholderText={formatMessage(messages.passwordLbl)}
                    {...inputFormProps}
                    onChange={(p) => setPassword(p)}
                    ref={(input) => {
                        setTxtPassword(input);
                    }}
                />
                <div className="login-options-div">
                    <div className="login-forgot-password">
                        <a
                            tabIndex={3}
                            href="#Recover Password"
                            onClick={(evt) => recoverPassword(evt)}
                        >
                            {formatMessage(messages.forgotPasswordLnk)}
                        </a>
                    </div>
                </div>
            </div>
            <div className="login-center">
                <Button
                    tabIndex={4}
                    className="login-btn"
                    type="login"
                    {...inputFormProps}
                    onClick={() => login()}
                />
            </div>
        </div>
    );
};

export default PasswordEntry;
